import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  showIcon?: boolean;
  variant?: 'primary' | 'sticky';
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  fullWidth = false,
  showIcon = true,
  variant = 'primary',
  className = '',
  href,
  onClick
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-serif font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-vintage-brown';
  const variants = {
    primary: 'bg-vintage-brown text-vintage-cream hover:bg-vintage-dark hover:-translate-y-1 shadow-lg hover:shadow-xl rounded-lg py-4 px-8 text-lg md:text-xl',
    sticky: 'bg-vintage-brown text-vintage-cream hover:bg-vintage-dark shadow-lg rounded-full py-3 px-6 text-base'
  };
  const classes = `
    ${baseStyles}
    ${variants[variant]}
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const content = <>
      <span className="mr-2" data-id="element-1">{children}</span>
      {showIcon && <ArrowRight className="w-5 h-5" data-id="element-2" />}
    </>;
  // Bulletproof click handler for links - opens in new tab
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href) {
      console.log('CTAButton clicked! Opening in new tab:', href);
      e.preventDefault();
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };
  // If href is provided, use anchor tag that opens in new tab
  if (href) {
    return <a href={href} onClick={handleLinkClick} target="_blank" rel="noopener noreferrer" className={classes} style={{
      textDecoration: 'none',
      cursor: 'pointer',
      pointerEvents: 'auto',
      position: 'relative',
      zIndex: 10
    }} data-id="element-3">
        {content}
      </a>;
  }
  // Otherwise use a button with motion
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} onClick={onClick} data-id="element-4">
      {content}
    </motion.button>;
}